<template lang='pug'>
.listing-container
  .row
    .col-12.col-lg-6(v-for='variant, index in variants' :key='index')
      variant-card(:variant='variant')
</template>
<script>
import VariantCard from '../../../landing-pages/four-groups/variant-card.vue'

export default {
  components: {
    VariantCard
  },
  props: {
    variants: {
      type: Array,
      default: () => [],
      required: true
    }
  }
}
</script>

<style lang='scss' scoped>
  .listing-container {
    width: 100%;
    margin-bottom: 20px;
  }

  .variant-card {
    max-width: 100%;
  }
</style>
